import type { FaireProductEntity } from "../../entity_types/product";

export const p_abcf3y58nt: FaireProductEntity = {
  token: "p_abcf3y58nt",
  type: "product",
  name: "Lip Balm, Sweet Mint",
  brandToken: "b_4uw0cexy",
  brandName: "Poppy & Pout",
  imageUrl: "https://cdn.faire.com/fastly/e23aaab423b3dc38219e531d2c2e1ff2075e26151d1e4cdc98fa2cc63eea3f73.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/57bfcef95bc67eb88332361dd4444d4484a33aed382ce0e0cd33827800a69a33.jpeg",
    "https://cdn.faire.com/fastly/e92eb7124d4c6712d04b2a795bb4e57543230db82c55d12d80c6e7bb57d0d79c.jpeg",
    "https://cdn.faire.com/fastly/0b273be14579fe25b2444f08563e01ed378ea599097935b521c1d35d7b93ca5c.jpeg",
    "https://cdn.faire.com/fastly/204daa293928030aef24059e799ed4c7706729b310248a5dbee1314ad48aec21.jpeg",
    "https://cdn.faire.com/fastly/150b04725ef8e7364e8c7a168e19205e6f06f31a89bd2100cb13fd155918de50.jpeg",
    "https://cdn.faire.com/fastly/5d3fa7ec9eb9547e647f4fd7024da877a949018a25a1c9db4ea00cea3a14cd1d.jpeg"
  ],
  priceDollars: 4.98,
  description: "Don't forget to add a lip balm tester and a few of our eco-friendly displays and retail signs!\n\n\nOur first ever lip balm, Sweet Mint, has been our best seller since the very beginning! We’ve perfected our recipe, which results in a perfectly smooth and minty lip balm.\n\nOur natural lip balm formula is super smooth and extremely hydrating. Each cardboard tube is filled from bottom to top with our all-natural product. When you're ready for more, simply push up from the bottom to reveal more of your favorite eco-friendly lip balm.\n\nPoppy & Pout has been making all-natural lip care products by hand in Idaho since 2014. All of our products are made from 100% natural ingredients. We believe simple ingredients are all you need for perfectly hydrated lips.\n\n100% NATURAL INGREDIENTS\nCocos Nucifera (Coconut) Oil, Cera Alba (Beeswax), Helianthus Annuus (Sunflower) Oil, Mentha Piperita Oil, Natural Flavor Oil\n\n100% Natural | Cruelty-Free (Leaping Bunny Certified) | Eco-Friendly\n\nNet Weight .3oz / 8.5g\n",
  tags: [],
  msrpDollars: 9.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-07T18:31:38.811Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
